import Vue from 'vue'
import Vuex from 'vuex'
// vue-cookies配置
import VueCookies from 'vue-cookies'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navList: [], // 菜单数据
        menuList: [], // 当前选中的二级菜单数据
        buttonData: {}, // 按钮权限数据
        menuItem: VueCookies.get('menuItem') || {}, // 当前激活菜单的item
        activePath: VueCookies.get('activePath') || '',
        userInfo: VueCookies.get('userInfo') ? VueCookies.get('userInfo') : {},
        activeIndex: VueCookies.get('activeIndex') ? VueCookies.get('activeIndex') : 0,
        isCollapse: false, // 菜单折叠状态
        unReadMessageCnt: null, // 未读消息数量
        chatMessageList: {}, // 互动消息列表
        chatPersonObj: {}, //聊天负责人
        showPopover: true, // 悬浮菜单显隐
        showAIDrawer: false, // 智能问答窗口显隐
        aiMessageData: [], // ai问答消息数据
        aiChatId: VueCookies.get('aiChatId') || '', // 当前ai对话的会话ID
        activityAiChatObj: {}, // ai帮写功能，如简易版使用AI写活动首页展示内容
        computedTable: false //筛选之后需要重新刷新表格布局
    },
    getters: {},
    mutations: {
        // 更新ai帮写功能对象
        renewActivityAiChatObj(state, data) {
            state.activityAiChatObj = data
        },
        // 更新智能问答窗口显隐状态
        renewShowAIDrawer(state, status) {
            state.showAIDrawer = status
        },
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.showPopover = !status
            state.isCollapse = status
        },
        // 更新悬浮菜单显隐
        renewShowPopover(state, status) {
            state.showPopover = status
        },
        // 更新AI问答消息数据
        renewAiMessageData(state, data) {
            state.aiMessageData = data
        },
        // 更新AI问答会话ID
        renewAiChatId(state, id) {
            state.aiChatId = id
        },
        // 更新菜单列表
        renewNavList(state, data) {
            state.navList = data
        },
        // 更新菜单列表
        renewMenuList(state, data) {
            state.menuList = data
        },
        // 更新按钮权限数据
        renewButtonData(state, data) {
            state.buttonData = data
        },
        // 更新激活菜单对象
        renewMenuItem(state, data) {
            state.menuItem = data
        },
        // 修改左侧菜单栏路径
        changeActivePath(state, path) {
            state.activePath = path
        },
        // 修改顶部菜单栏索引
        changeActiveIndex(state, index) {
            state.activeIndex = index
        },
        // 更新用户信息
        renewUserInfo(state, data) {
            state.userInfo = data
        },
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.isCollapse = status
        },
        // 更新未读消息数量
        renewUnReadMessageCnt(state, data) {
            state.unReadMessageCnt = data
        },
        // 更新聊天负责人数据
        renewChatPersonObj(state, obj) {
            state.chatPersonObj = obj
        },
        // 更新未读互动消息数据
        renewChatMessageList(state, list) {
            state.chatMessageList = list
        },
        //  更新是否需要重新刷新表格布局
        renewComputedTable(state, data) {
            state.computedTable = data
        }
    },
    actions: {},
    modules: {}
})
